// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import constants from "@store/constants";
import { getDocumentsWrapper } from "@store/Framework/Common/Utilities/getDocumentsWrapper";
import useTrackExportHistory from "@store/Framework/GoogleAnalytics/hooks/useTrackExportHistory";
import { getTrailerOverview } from "@store/Framework/Services/documentService";
import { TrailersDataViewContext } from "@store/Framework/Store/Greif/Data/Trailers/TrailersSelectors";
import { historyFilterProps } from "@store/Themes/common/props/history";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface TrailerOverviewExportButtonStyles {
    exportButton?: ButtonPresentationProps;
    wrapper?: InjectableCss;
}

export const exportButtonStyles: TrailerOverviewExportButtonStyles = {
    exportButton: historyFilterProps.exportButton,
    wrapper: {
        css: css`
            display: flex;
            justify-content: right;
            width: 100%;
        `,
    },
};

const styles = exportButtonStyles;

const TrailerOverviewExportButton: React.FC<Props> = () => {
    const trailersDataView = useContext(TrailersDataViewContext);
    const [fileIsLoading, setFileIsLoading] = React.useState(false);

    const toasterContext = React.useContext(ToasterContext);
    const trackExportHistory = useTrackExportHistory();

    let totalItemCount = 0;
    if (trailersDataView.value) {
        totalItemCount = trailersDataView.value.length || 0;
    }

    const exportTrailerOverviewHistory = () => {
        getDocumentsWrapper(
            getTrailerOverview,
            setFileIsLoading,
            { parameter: window.location.search },
            toasterContext,
        ).then(e => {
            if (e) {
                trackExportHistory({ file_category: "TrailerTracking Export" });
            }
        });
    };

    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                <Button
                    {...styles.exportButton}
                    data-test-selector="trailerTracking_exportFilters"
                    onClick={exportTrailerOverviewHistory}
                    isLoading={fileIsLoading}
                    disabled={!totalItemCount}
                >
                    {translate("Trailer Overview")}
                </Button>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: TrailerOverviewExportButton,
    definition: {
        group: constants.widgetGroup.trailerTracking,
        displayName: "Export Overview Button",
        allowedContexts: [constants.pageType.trailerTracking],
    },
};

export default widgetModule;
